import {
  clearAvCookies,
  clearHardContentGateCookies,
  clearProvinceCookies,
  LOCAL_USER_UPDATED_EVENT,
  removeCookie,
  setCookie,
  setProvinceCookies,
} from "@jti/fe-common";
import { type IUser } from "@jti/rest-api-types";

import BrowserStorage from "./BrowserStorage";
import { calculateExpireDate } from "./calculateExpireDate";

export class User {
  constructor(private browserStorage: BrowserStorage) {}

  private getDefaultUser(): IUser {
    return {
      consent_renewal_required: false,
      is_age_verified: false,
      is_device_registered: false,
      unique_id: -1,
      first_name: "",
      last_name: "",
      email: "",
      ciam_token: "",
      magento_token: "",
      session_token: "",
    };
  }

  getUser(): IUser {
    return {
      ...this.getDefaultUser(),
      ...this.browserStorage.get("user", {}),
    };
  }

  setUser(values: Partial<IUser>): void {
    setCookie("isUserLoggedIn", true, "/", calculateExpireDate(7).toUTCString());
    setProvinceCookies(values?.province_name);
    const user = this.getUser();
    this.browserStorage.set("user", {
      ...this.getDefaultUser(),
      ...user,
      ...values,
    });
  }

  clearUser(): void {
    removeCookie("isUserLoggedIn", "/");
    removeCookie("productsOwned", "/");
    clearProvinceCookies();
    clearHardContentGateCookies();
    clearAvCookies();
    this.browserStorage.set("user", null);
    window.dispatchEvent(new Event(LOCAL_USER_UPDATED_EVENT));
  }
}

export const setUsersDeviceStatus = (hasDevices: boolean): void => {
  const browserStorage = new BrowserStorage();
  const user = getUser();
  browserStorage.set("user", {
    ...user,
    has_registered_device: hasDevices,
    is_device_registered: hasDevices,
  });
  window.dispatchEvent(new Event(LOCAL_USER_UPDATED_EVENT));
};

export const getUser = (): IUser => {
  const session = new User(new BrowserStorage());

  return session.getUser();
};

export const clearUser = () => {
  const session = new User(new BrowserStorage());

  return session.clearUser();
};

export default User;
